import { l } from '../../lib/imports'
import { stevieTexts2 } from '../../uiParts/stevieTexts2-sidecar'
import { echoFonts } from '../echo/echoFonts-sidecar'
import { voyageJsonServerInterface } from './voyageJsonServerInterface-sidecar'
import { voyageLayers } from './voyageLayers-sidecar'
import { voyageSaver } from './voyageSaver-sidecar'
import type { IVoyageUiCanvas } from './voyageUiCanvas'
import { voyageUiCanvas } from './voyageUiCanvas-sidecar'
import { voyageUiGButtons } from './voyageUiGButtons-sidecar'
import { voyageUiGraphicsUtils } from './voyageUiGraphicsUtils-sidecar'

interface IVoyageUiLoadShip extends IVoyageUiCanvas {
  // selectedBattle: IGoatBattleData | null
}

let _obj: IVoyageUiLoadShip | null = null
export function get() {
  if (!_obj) {
    _obj = create()
    setOpen(false)
    updateList(['!'])
    render()
  }
  return _obj
}

const create = () => {
  let tw = 700
  let th = 800
  let canvas = voyageUiCanvas.create(tw, th, voyageLayers.getLayers().uiMenu)
  canvas.ox = 0
  canvas.oy = 0

  let obj: IVoyageUiLoadShip = voyageUiCanvas.assign<IVoyageUiLoadShip>(
    canvas,
    {
      selectedBattle: null,
    },
  )

  return obj
}

const updateList = (list: string[]) => {
  let x = 20
  let y = 40
  let obj = get()
  const addButton = (
    text: string,
    action: () => void,
    onMouseOver: () => void,
  ) => {
    let button = voyageUiGButtons.create(text, x, y, action)
    button.onMouseOver = onMouseOver
    button.w = 200
    obj.buttons.push(button)
    y += 60
    if (y > obj.targetHeight - 60) {
      x += 200 + 20
      y = 40
    }
  }

  obj.buttons = []

  l.forEach(list, (c) => {
    addButton(
      c,
      () => {
        //goatGameModeManager.goProtoBattle()
        // goatGameMode_freeBuild.setFilename(c)
        voyageSaver.load(c)
        setOpen(false)
      },
      () => {
        // get().selectedBattle = c
      },
    )
  })

  y += 60
  addButton(
    'Cancel',
    () => {
      setOpen(false)
    },
    () => {},
  )
}

const render = () => {
  let obj = get()
  let g = obj.graphics

  voyageUiCanvas.clear(obj)
  if (!obj.isOpen) {
    return
  }

  let addText = (text: string, x: number, y: number) => {
    let _text = stevieTexts2.create(echoFonts.getData().font6, x, y, obj.layer)
    stevieTexts2.setText(_text, text)
    stevieTexts2.setScale(_text, 3)

    obj.texts.push(_text)
    return _text
  }

  let x = 0
  let y = 0
  let w = obj.targetWidth
  let h = obj.targetHeight

  voyageUiGraphicsUtils.bevelPanel(g, x, y, w, h)
  addText('Load Ship Design', x + 6, y) // + 25 - 2)

  x = 400
  y = 60
  // let b = obj.selectedBattle
  // if (b) {
  //   addText(b.name, x, y)
  //   y += 40
  //   addText(b.desc, x, y)
  //   y += 40
  //   addText('Budget: $' + b.budget, x, y)
  // }

  voyageUiCanvas.render(obj)
}

export const setOpen = (isOpen: boolean) => {
  let obj = get()

  if (isOpen && !obj.isOpen) {
    voyageJsonServerInterface.list((list) => {
      updateList(list)
    })
  }

  voyageUiCanvas.setOpen(obj, isOpen)
  update()
}

export const update = () => {
  let obj = get()

  voyageUiCanvas.update(obj)
  render()
}
